class CompareAnalysis extends Analysis {
    constructor(comparisonGroup, comparisonGroupTitle, companiesConsidered, cutoff, modelCode, title, listID) {
        super(companiesConsidered, cutoff, modelCode, title, listID);
        this.comparisonGroup = comparisonGroup;
        this.comparisonGroupTitle = comparisonGroupTitle;
    }

    processAnalysisResponse(analysisResponse) {
        super.processAnalysisResponse(analysisResponse);
        if (this.analysisFieldAvailable(analysisResponse, "CompanyFoundingDates") && analysisResponse.CompanyFoundingDates.length > 0) {
            const companyDetailsKnowledgeBaseLink = this.formatKnowledgeBaseTooltipLink("https://help.thedatacity.com/knowledge/using-analyse#company-details");
            let tooltipText = `This graph represents the cumulative growth of companies within the selected filters. It uses the incorporation date of active companies. Companies that have dissolved are not visualised.<br><br>For example, if a specific RTIC was selected (e.g. AI), for a previous year it does not represent how many AI businesses were classified in that year. It is showing data only for companies which are now part of the AI RTIC.${companyDetailsKnowledgeBaseLink}`
            this.newAnalysisField("CompanyFoundingDates", "Company founding dates", "Company details", "numerical", tooltipText, "line", ["bar", "line"], "Year", null, false, null, "Founding dates").addAnalysisFieldElements(analysisResponse.CompanyFoundingDates.reverse(), "Year");
        }
    }

    newComparisonGroupTitle(title) {
        this.comparisonGroupTitle = title;
        return this;
    }

    newAnalysisField(field, label, subsection, dataType, explanation, chartType, allowedChartTypes, thingColumnLabel, emptyFieldLabel, displayDataAsPercentage, locationFilterField) {
        let analysisField = new CompareAnalysisField(field, label, subsection, dataType, explanation, chartType, allowedChartTypes, this.listID, thingColumnLabel, emptyFieldLabel, displayDataAsPercentage, locationFilterField, this.comparisonGroup, this.comparisonGroupTitle, this);
        this.fields.push(analysisField);
        return analysisField;
    }

    // Check whether analyis is restricted in some way to registered addresses
    analysisFilteredByRegisteredAddresses() {
        return (document.getElementById(`${this.comparisonGroup}calculateInsightsBasedOnlyOnRegisteredAddresses`).checked && document.getElementById(`${this.comparisonGroup}registeredAddressOnly`).checked);
    }

    addResultsToAnalysisSummary(contentHolder) {
        super.addResultsToAnalysisSummary(contentHolder);
        const summaryElements = contentHolder.querySelectorAll(".analysisSummaryElement");
        summaryElements.forEach(element => element.prepend(coreFunctions.createElementHelper("div", {class: "summaryLabel compareGroupTitleElement", innerHTML: this.comparisonGroupTitle, "data-compare-element": this.comparisonGroup })));
        return this;
    }

    createSummaryTableContent() {
        return holder;
    }


}

class CompareAnalysisField extends AnalysisField {
    constructor(field, label, subsection, dataType, explanation, chartType, allowedChartTypes, listID, thingColumnLabel, emptyFieldLabel, displayDataAsPercentage, locationFilterField, comparisonGroup, comparisonGroupTitle, parent) {
        super(field, label, subsection, dataType, explanation, chartType, allowedChartTypes, listID, thingColumnLabel, emptyFieldLabel, displayDataAsPercentage, locationFilterField);
        this.parent = parent;
        this.topCompanies = new CompareTopCompanies(field, label, dataType, comparisonGroup);
        this.comparisonGroup = comparisonGroup;
        this.comparisonGroupTitle = comparisonGroupTitle;
    }

    newAnalysisFieldElement(field, thing, count, latitude, longitude, dataType, thingColumnLabel, quotient) {
        let analysisFieldElement = new CompareAnalysisFieldElement(field, thing, count, latitude, longitude, dataType, thingColumnLabel, quotient, this.comparisonGroup, this.comparisonGroupTitle);
        this.fieldElements.push(analysisFieldElement);
        return analysisFieldElement;
    }

    newAnalysisFinancialFieldElement(year, measuredYearValue, measuredYearCompanies, projectedYearValue, projectedYearCompanies, dataType) {
        let analysisFieldElement = new CompareAnalysisFinancialFieldElement(year, measuredYearValue, measuredYearCompanies, projectedYearValue, projectedYearCompanies, dataType, this.comparisonGroup, this.comparisonGroupTitle);
        this.fieldElements.push(analysisFieldElement);
        return analysisFieldElement;
    }
}

class CompareAnalysisFieldElement extends AnalysisFieldElement {
    constructor (field, thing, count, latitude, longitude, dataType, thingColumnLabel, quotient, comparisonGroup, comparisonGroupTitle)  {
        super(field, thing, count, latitude, longitude, dataType, thingColumnLabel, quotient);
        this.comparisonGroup = comparisonGroup;
        this.comparisonGroupTitle = comparisonGroupTitle;
    }

    createBarchartElement(maximumCount, emptyFieldLabel, isPercapitaData, perCapitaMultiplier, totalCount, displayAsPercentage, plotLocationQuotient) {
        let barElementLi = super.createBarchartElement(maximumCount, emptyFieldLabel, isPercapitaData, perCapitaMultiplier, totalCount, displayAsPercentage, plotLocationQuotient);
        let barHolder = coreFunctions.createElementHelper("span", {class: "barHolder", innerHTML: barElementLi.innerHTML, "data-compare_element": this.comparisonGroup });
        return barHolder;
    }

    createPercentageBarchartElement(maximumCount) {
        let maxWidth = 40;
        let barElementLi = super.createPercentageBarchartElement(maximumCount, maxWidth);
        let barHolder = coreFunctions.createElementHelper("span", {class: "barHolder", innerHTML: barElementLi.innerHTML, "data-compare_element": this.comparisonGroup });
        return barHolder;
    }

    formatElementForCsv() {
        const row = [];
        if (this.dataType == "percentage") {
            row.push(this.count * 100);
        } else if (this.count) {
            row.push(this.count);
        } else {
            row.push("");
        }
        return row;
    }

    processElementForCompleteDownload() {
        const processedElementObject = {};
        if (this.dataType == "percentage") {
            processedElementObject[`${this.comparisonGroupTitle} percentage`] = Number((this.count * 100).toFixed(0));
        } else {
            processedElementObject[`${this.comparisonGroupTitle} count`] = this.count;
        }
        return processedElementObject;
    }

}

class CompareAnalysisFinancialFieldElement extends AnalysisFinancialFieldElement {
    constructor (year, measuredYearValue, measuredYearCompanies, projectedYearValue, projectedYearCompanies, dataType, comparisonGroup, comparisonGroupTitle) {
        super(year, measuredYearValue, measuredYearCompanies, projectedYearValue, projectedYearCompanies, dataType);
        this.comparisonGroup = comparisonGroup;
        this.comparisonGroupTitle = comparisonGroupTitle;
    }

    createFinancialsBarchartElement(maximumCount) {
        let barElementLi = super.createFinancialsBarchartElement(maximumCount);
        let barHolder = coreFunctions.createElementHelper("span", {class: "barHolder", innerHTML: barElementLi.innerHTML, "data-compare_element": this.comparisonGroup });
        return barHolder;
    }

    formatElementForCsv() {
        return [this.measuredTotal, this.measuredCompanies, this.projectedTotal, this.projectedCompanies];
    }

    processElementForCompleteDownload() {
        const processedElementObject = {}
        processedElementObject[`${this.comparisonGroupTitle} measured total (GBP)`] = this.measuredTotal;
        processedElementObject[`${this.comparisonGroupTitle} measured companies`] = this.measuredCompanies;
        processedElementObject[`${this.comparisonGroupTitle} projected total (GBP)`] = this.projectedTotal;
        processedElementObject[`${this.comparisonGroupTitle} projected companies`] = this.projectedCompanies;
        return processedElementObject;
    }
}

class CompareTopCompanies extends TopCompanies {
    constructor(field, label, dataType, comparisonGroup) {
        super (field, label, dataType);
        this.comparisonGroup = comparisonGroup;
    }

    newTopCompany(companyName, companyNumber, total, dataType) {
        let topCompany = super.newTopCompany(companyName, companyNumber, total, dataType);
        if (topCompany) {
            topCompany.comparisonGroup = this.comparisonGroup;
        }
        return topCompany;
    }

    addTopCompaniesToPage() {
        let topCompaniesHolder = super.addTopCompaniesToPage();
        if (topCompaniesHolder) {
            topCompaniesHolder.setAttribute("data-compare-element", this.comparisonGroup);
        }
    }

}

class CompareLinechart {
    constructor(field, elements, label, dataType, compareOneTitle, compareTwoTitle) {
        this.field = field;
        this.label = label;
        this.elements = elements;
        this.dataType = dataType;
        this.compareOneLinechartData = null;
        this.compareTwoLinechartData = null;
        this.compareOneTitle = compareOneTitle;
        this.compareTwoTitle = compareTwoTitle;
        this.numberOfGridlines = 5;
    }

    prepareLinechartHolder() {
        let linechartContentWrapper;
        linechartContentWrapper = coreFunctions.createElementHelper("div", { class: "barchartContentWrapper", id: `${this.field}ChartContentWrapper`, field: this.field, charttype: "line" });
        if (this.dataType == "currency") {
            linechartContentWrapper.appendChild(this.addFinancialsLinechartKey());
        } else {
            linechartContentWrapper.appendChild(this.addLinechartKey());
        }

        document.querySelector(`.barchartHolder[field='${this.field}']`).appendChild(linechartContentWrapper);

        linechartContentWrapper.appendChild(coreFunctions.createElementHelper("div", { class: "linechartHolder chartWrapper", id: `${this.field}LineChart`})).appendChild(coreFunctions.createElementHelper("canvas", {id: `${this.field}LineChartCanvas`}));

        if (this.field == "CompanyFoundingDates") {
            document.querySelector(`.barchartHolder[field='${this.field}'] .widgetTitle`).innerHTML = "Cumulative companies founded over time";
        }
        return this;
    }

    drawCumulativeLinechart() {
        const ctx = document.getElementById(`${this.field}LineChartCanvas`).getContext('2d');
        let compareOneSum = 0, compareTwoSum = 0;
        if (this.scatterChart) {
            this.scatterChart.destroy();
        }
        this.compareOneLinechartData = Object.assign([], this.elements.filter(element => element.compareOne)).reverse().map(element => ({x: element.compareOne.thing, y: compareOneSum += element.compareOne.count}));
        this.compareTwoLinechartData = Object.assign([], this.elements.filter(element => element.compareTwo)).reverse().map(element => ({x: element.compareTwo.thing, y: compareTwoSum += element.compareTwo.count}));

        const data = {
            datasets: [{
                label: this.compareOneTitle,
                data: this.compareOneLinechartData,
                fill: false,
                showLine: true,
                borderColor: '#02B1D0',
                borderWidth: 3,
                pointRadius: 2,
                tension: 0.1,
                display: true
            },{
                label: this.compareTwoTitle,
                data: this.compareTwoLinechartData,
                fill: false,
                showLine: true,
                borderColor: '#D10956',
                borderWidth: 3,
                pointRadius: 2,
                tension: 0.1,
                display: true
            }]
        };
        this.scatterChart = new Chart(ctx, {
            type: 'scatter',
            data: data,
            options: {
                animation: false,
                aspectRatio: 1.7,
                scales: {
                    x: {
                        beginAtZero: false,
                        title: {
                            display: false,
                            text: "Year",
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular'
                            }
                        },
                        min: 2000,
                        ticks: {
                            min: 2000,
                            callback: function (value, index, values) {
                              return (Number.isInteger(value)) ? value.toString() : null;
                            },
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular',
                                size: 13
                            }
                        },
                        grid: {
                            borderColor: "rgba(0, 0, 0, 0)",
                            color: "#4f5251",
                            display: false,
                        }
                    },
                    y: {
                        beginAtZero: true,
                        title: {
                            display: false,
                            text: "Count",
                            color: '#FFFFFF',
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular'
                            }
                        },
                        ticks: {
                            callback: function (value, index, values) {
                                return value.toLocaleString();
                            },
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular',
                                size: 13
                            },
                            maxTicksLimit: 7
                        },
                        grid: {
                            borderColor: "rgba(0, 0, 0, 0)",
                            color: "#4f5251",
                            drawTicks: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                    }, title: {
                        display: false,
                        text: `Usage statistics`,
                        color: '#FFFFFF'
                    },
                    tooltip: {
                        titleFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        bodyFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        footerFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label + " count: ";
                                if (context.parsed.y !== null) {
                                  label += context.parsed.y.toLocaleString();
                                }
                                if (context.parsed.x !== null) {
                                    label += ` (${context.parsed.x})`;
                                }
                                return label;
                            }
                        }
                    },
                    datalabels: {
                        anchor: 'center',
                        align: 'right',
                        offset: 5,
                        clamp: true,
                        font: {
                            weight: 'bold'
                        },
                        formatter: function (value, context) {
                            return context.dataset.label;
                        },
                        color: function (context) {
                            return context.dataset.borderColor;
                        },
                        display: function (context) { return (context.dataIndex === 0); }
                    }
                }
            }
        });
        return this;
    }

    drawTimestampLineChart() {
        const ctx = document.getElementById(`${this.field}LineChartCanvas`).getContext('2d');
        const linechartElementsSorted = this.elements.sort((a,b) => moment(a.thing, "YYYY-MM").unix() - moment(b.thing, "YYYY-MM").unix());
        const data = {
            datasets: [{
                label: this.compareOneTitle,
                data: linechartElementsSorted.flatMap(element => element.compareOne ? [{ x: moment(element.compareOne.thing, "YYYY-MM"), y: element.compareOne.count}] : []),
                fill: false,
                showLine: true,
                borderColor: '#02B1D0',
                borderWidth: 3,
                pointRadius: 2,
                tension: 0.1,
                display: true
            },{
                label: this.compareTwoTitle,
                data: linechartElementsSorted.flatMap(element => element.compareTwo ? [{ x: moment(element.compareTwo.thing, "YYYY-MM"), y: element.compareTwo.count}] : []),
                fill: false,
                showLine: true,
                borderColor: '#D10956',
                borderWidth: 3,
                pointRadius: 2,
                tension: 0.1,
                display: true
            }]
        };
        const scatterChart = new Chart(ctx, {
            type: 'scatter',
            data: data,
            options: {
                animation: false,
                aspectRatio: 1.7,
                scales: {
                    x: {
                        beginAtZero: false,
                        title: {
                            display: false,
                            text: "Year",
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular'
                            }
                        },
                        ticks: {
                            callback: function (value, index, values) {
                                return moment(value, "x").format("YYYY-MM");
                            },
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular',
                                size: 13
                            }
                        },
                        grid: {
                            borderColor: "rgba(0, 0, 0, 0)",
                            color: "#4f5251",
                            display: false,
                        }
                    },
                    y: {
                        beginAtZero: true,
                        title: {
                            display: false,
                            text: "Count",
                            color: '#FFFFFF',
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular'
                            }
                        },
                        ticks: {
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular',
                                size: 13
                            },
                            maxTicksLimit: 7
                        },
                        grid: {
                            borderColor: "rgba(0, 0, 0, 0)",
                            color: "#4f5251",
                            drawTicks: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: false,
                        color: '#FFFFFF'
                    },
                    tooltip: {
                        titleFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        bodyFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        footerFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += Number(context.parsed.y.toFixed(1)).toLocaleString();
                                }
                                if (context.parsed.x !== null) {
                                    label += ` (${moment(context.parsed.x, "x").format("YYYY-MM")})`;
                                }
                                return label;
                            }
                        }
                    },
                    datalabels: {
                        anchor: 'center',
                        align: 'right',
                        offset: 5,
                        clamp: true,
                        font: {
                            weight: 'bold'
                        },
                        formatter: function (value, context) {
                            return context.dataset.label;
                        },
                        color: function (context) {
                            return context.dataset.borderColor;
                        },
                        display: function (context) { return (context.dataIndex === 0); }
                    }
                }
            }
        });
        return this;
    }

    drawLinechart() {
        const lineChartObject = this;
        const ctx = document.getElementById(`${this.field}LineChartCanvas`).getContext('2d');

        this.compareOneLinechartData = Object.assign([], this.elements.filter(element => element.compareOne).map(element => element.compareOne));
        this.compareTwoLinechartData = Object.assign([], this.elements.filter(element => element.compareTwo).map(element => element.compareTwo));

        if (this.scatterChart) {
            this.scatterChart.destroy();
        }

        const data = {
            datasets: [{
                label: `${this.compareOneTitle} measured`,
                data:  this.compareOneLinechartData.filter(element => element.measuredTotal).map(element => ({ x: element.year, y: element.measuredTotal })),
                fill: false,
                showLine: true,
                borderColor: '#02B1D0',
                borderWidth: 3,
                pointRadius: 2,
                tension: 0.1,
                display: true
            }, {
                label: `${this.compareOneTitle} projected`,
                data: this.compareOneLinechartData.filter(element => element.projectedTotal).map(element => ({ x: element.year, y: element.projectedTotal })),
                fill: false,
                showLine: true,
                borderColor: 'rgba(2, 177, 208, 0.7)',
                borderWidth: 3,
                borderDash: [10,5],
                pointRadius: 2,
                tension: 0.1,
                display: true
            },{
                label: `${this.compareTwoTitle} measured`,
                data:  this.compareTwoLinechartData.filter(element => element.measuredTotal).map(element => ({ x: element.year, y: element.measuredTotal })),
                fill: false,
                showLine: true,
                borderColor: '#D10956',
                borderWidth: 3,
                pointRadius: 2,
                tension: 0.1,
                display: true
            }, {
                label: `${this.compareTwoTitle} projected`,
                data: this.compareTwoLinechartData.filter(element => element.projectedTotal).map(element => ({ x: element.year, y: element.projectedTotal })),
                fill: false,
                showLine: true,
                borderColor: 'rgba(209, 9, 86, 0.7)',
                borderWidth: 3,
                borderDash: [10,5],
                pointRadius: 2,
                tension: 0.1,
                display: true
            }]
        };
        this.scatterChart = new Chart(ctx, {
            type: 'scatter',
            data: data,
            options: {
                animation: false,
                aspectRatio: 1.7,
                scales: {
                    x: {
                        beginAtZero: false,
                        title: {
                            display: false,
                            text: "Year",
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular'
                            }
                        },
                        ticks: {
                            callback: function (value, index, values) {
                              return (Number.isInteger(value)) ? value.toString() : null;
                            },
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular',
                                size: 13
                            }
                        },
                        grid: {
                            borderColor: "rgba(0, 0, 0, 0)",
                            color: "#4f5251",
                            display: false,
                        }
                    },
                    y: {
                        beginAtZero: true,
                        title: {
                            display: false,
                            text: "Count",
                            color: '#FFFFFF',
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular'
                            }
                        },
                        ticks: {
                            callback: function (value, index, values) {
                                return lineChartObject.formatLinechartLabel(value, false);
                            },
                            color: "#FFFFFF",
                            font: {
                                family: 'Gilmer-Regular, Poppins-Regular',
                                size: 13
                            },
                            maxTicksLimit: 7
                        },
                        grid: {
                            borderColor: "rgba(0, 0, 0, 0)",
                            color: "#4f5251",
                            drawTicks: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                    }, title: {
                        display: false,
                        text: `Usage statistics`,
                        color: '#FFFFFF'
                    },
                    tooltip: {
                        titleFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        bodyFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        footerFont: {
                            family: 'Gilmer-Regular, Poppins-Regular',
                        },
                        displayColors: false,
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label || '';

                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += lineChartObject.formatLinechartLabel(context.parsed.y, false);
                                }
                                if (context.parsed.x !== null) {
                                    label += ` (${context.parsed.x})`;
                                }
                                return label;
                            }
                        }
                    },
                    datalabels: {
                        anchor: 'center',
                        align: 'right',
                        offset: 5,
                        clamp: true,
                        font: {
                            weight: 'bold'
                        },
                        formatter: function (value, context) {
                            return context.dataset.label;
                        },
                        color: function (context) {
                            return context.dataset.borderColor;
                        },
                        display: function (context) { return (context.dataIndex === 0); }
                    }
                }
            }
        });
        return this;
    }

    formatLinechartLabel(value, formatFree) {
        let formattedValue = Math.abs(value);

        const si = [
            {
                value: 1,
                symbol: ""
            },
            {
                value: 1E3,
                symbol: "k"
            },
            {
                value: 1E6,
                symbol: "M"
            },
            {
                value: 1E9,
                symbol: "bn"
            },
            {
                value: 1E12,
                symbol: "tn"
            },
            {
                value: 1E15,
                symbol: "P"
            },
            {
                value: 1E18,
                symbol: "E"
            }
        ];
        var i;
        for (i = si.length - 1; i > 0; i--) {
            if (formattedValue >= si[i].value) {
                break;
            }
        }

        if (this.dataType == "currency") {
            if (value < 0) {
                formattedValue = Number(Math.abs((value / si[i].value).toFixed(1))).toLocaleString() + si[i].symbol;
                if (formatFree) {
                    formattedValue = "-£" + formattedValue;
                } else {
                    formattedValue = "-£" + formattedValue;
                }
            } else {
                formattedValue = Number((value / si[i].value).toFixed(1)).toLocaleString() + si[i].symbol;
                formattedValue = "£" + formattedValue;
            }
        } else {
            formattedValue = Number((value / si[i].value).toFixed(1)).toLocaleString() + si[i].symbol;
        }

        return formattedValue;
    }

    addLinechartKey() {
        let linechartKey = coreFunctions.createElementHelper("div", { class: "keyHolder", innerHTML: `<span class='keyElement' data-compare_element='compareOne'><span class='keySquare measured line'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${compare.comparison.compareOne.title}</span></span></span><span class='keyElement' data-compare_element='compareOne'><span class='keyElement' data-compare_element='compareTwo'><span class='keySquare measured line'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${compare.comparison.compareTwo.title}</span></span></span>` });
        return linechartKey;
    }

    addFinancialsLinechartKey() {
        let financialsKey, fieldCompanyTotalsHolder, fieldCompanyTotalsCheckbox, fieldCompanyTotalsLabel, fieldCompanyTotals, fieldCompanyCountsHolder;
        // financialsKey = coreFunctions.createElementHelper("div", { class: "financialsKey", innerHTML: "<span class='keyElement'><span class='keySquare measured line'>&nbsp;</span><span class='keyLabel'>Measured</span></span><span class='keyElement'><span class='keySquare projected line'>&nbsp;</span><span class='keyLabel'>Projected</span></span>" });

        financialsKey = coreFunctions.createElementHelper("div", { class: "keyHolder", innerHTML: `<span class='keyElement' data-compare_element='compareOne'><span class='keySquare measured line'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${compare.comparison.compareOne.title}</span> measured</span></span><span class='keyElement' data-compare_element='compareOne'><span class='keySquare projected line'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${compare.comparison.compareOne.title}</span> projected</span></span><span class='keyElement' data-compare_element='compareTwo'><span class='keySquare measured line'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${compare.comparison.compareTwo.title}</span> measured</span></span><span class='keyElement' data-compare_element='compareTwo'><span class='keySquare projected line'>&nbsp;</span><span class='keyLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${compare.comparison.compareTwo.title}</span> projected</span></span>` });

        // fieldCompanyTotalsHolder = financialsKey.appendChild(coreFunctions.createElementHelper("span", { "class": "companyTotalsControlHolder" }));
        // fieldCompanyTotalsCheckbox = fieldCompanyTotalsHolder.appendChild(coreFunctions.createElementHelper("input", { type: "checkbox", id: `companyTotalsCheckbox${this.field}` }));
        // fieldCompanyTotalsLabel = fieldCompanyTotalsHolder.appendChild(coreFunctions.createElementHelper("label", { for: `companyTotalsCheckbox${this.field}`, innerHTML: "?" }));
        // fieldCompanyTotals = fieldCompanyTotalsLabel.appendChild(coreFunctions.createElementHelper("span", { class: "fieldCompanyTotals" }));
        // fieldCompanyTotals.appendChild(coreFunctions.createElementHelper("span", { "class": "fieldCompanyTotalsElement", innerHTML: "Projected data (shown in brackets) uses the most recently filed accounts to predict years for which accounts are not yet filed." })); // Explanation message
        // fieldCompanyCountsHolder = fieldCompanyTotals.appendChild(coreFunctions.createElementHelper("span", { class: "companyCountsHolder fieldCompanyTotalsElement" })).appendChild(coreFunctions.createElementHelper("ul"));

        // this.elements.forEach(element => fieldCompanyCountsHolder.appendChild(element.formatYearlyCompanyTotals()));
        // fieldCompanyCountsHolder.appendChild(coreFunctions.createElementHelper("li", { innerHTML: '<span class="explanation">No. of companies reporting</span>' }));

        return financialsKey;
    }

    addCumulativeLinechartSummary() {
        let holder, compareOneGrowthValue, compareTwoGrowthValue, recentResultsToProcess, compareOneCumulativeValuesForSummary, compareTwoCumulativeValuesForSummary, compareOneHolderContent, compareTwoHolderContent;
        const percentFormat = new Intl.NumberFormat('en', { style: 'percent', signDisplay: 'exceptZero', maximumSignificantDigits: 3, minimumSignificantDigits: 2});

        recentResultsToProcess = 10;
        compareOneCumulativeValuesForSummary = this.compareOneLinechartData.slice(-1 * recentResultsToProcess);
        compareTwoCumulativeValuesForSummary = this.compareTwoLinechartData.slice(-1 * recentResultsToProcess);

        compareOneGrowthValue = (compareOneCumulativeValuesForSummary[compareOneCumulativeValuesForSummary.length - 1].y - compareOneCumulativeValuesForSummary[0].y) / compareOneCumulativeValuesForSummary[0].y;
        compareTwoGrowthValue = (compareTwoCumulativeValuesForSummary[compareTwoCumulativeValuesForSummary.length - 1].y - compareTwoCumulativeValuesForSummary[0].y) / compareTwoCumulativeValuesForSummary[0].y;

        holder = coreFunctions.createElementHelper("div", {class: "compareCumulativeSummaryHolder"});

        // Total active companies for compare group 1
        compareOneHolderContent = `<div class='cumulativeElement'><div class='cumulativeTotal' data-compare-element='compareOne'>${compareOneCumulativeValuesForSummary[compareOneCumulativeValuesForSummary.length - 1].y.toLocaleString()}</div><div class='cumulativeLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${this.compareOneTitle}</span> companies founded</div></div>`;

        // Percentage change over the last 10 years for compare group 1
        compareOneHolderContent += `<div class='cumulativeElement'><div class='cumulativeTotal green'>${percentFormat.format(compareOneGrowthValue)}</div><div class='cumulativeLabel'><span class='compareGroupTitleElement' data-compare-element='compareOne'>${this.compareOneTitle}</span> growth: ${compareOneCumulativeValuesForSummary[0].x} -  ${compareOneCumulativeValuesForSummary[compareOneCumulativeValuesForSummary.length - 1].x}</div></div>`;

        compareTwoHolderContent = `<div class='cumulativeElement'><div class='cumulativeTotal' data-compare-element='compareTwo'>${compareTwoCumulativeValuesForSummary[compareTwoCumulativeValuesForSummary.length - 1].y.toLocaleString()}</div><div class='cumulativeLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${this.compareTwoTitle}</span> companies founded</div></div>`;

        // Percentage change over the last 10 years for compare group 2
        compareTwoHolderContent += `<div class='cumulativeElement'><div class='cumulativeTotal green'>${percentFormat.format(compareTwoGrowthValue)}</div><div class='cumulativeLabel'><span class='compareGroupTitleElement' data-compare-element='compareTwo'>${this.compareTwoTitle}</span> growth: ${compareTwoCumulativeValuesForSummary[0].x} -  ${compareTwoCumulativeValuesForSummary[compareTwoCumulativeValuesForSummary.length - 1].x}</div></div>`;

        holder.appendChild(coreFunctions.createElementHelper("div", { class: "cumulativeDataHolder", innerHTML: compareOneHolderContent }));

        holder.appendChild(coreFunctions.createElementHelper("div", { class: "cumulativeDataHolder", innerHTML: compareTwoHolderContent }));

        document.querySelector(`.barchartHolder[field='${this.field}'] .barchartContentWrapper`).appendChild(holder);

        return this;
    }
}